/** API route map: URLS.Controller.Roles */
export const Roles = {
      Name: 'Role/',
      GetAll: 'get-role',
      AddRole: 'add-role',
      EditRole: 'update-role',
      DeleteRole: 'delete-role',
      GetRoleRights: 'get-rolerights',
      CheckAssigned: 'get-assignedroles',
      SetRoleStatus: 'set-rolestatus',
};
